import { useState, useEffect } from "react";
import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useDispatch } from "react-redux";
import BarStackedData from "./BarStackedData";
import BarStackedDataAPI from "./BarStackedDataAPI";
import baseServices from "../../../services/base.services";
import { startLineChart } from "../../../actions/entryDataChart";

const BarStacked = ({ url, body, isCard, titleCard }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState([]);

  useEffect(() => {
    const getData = async () => {
      try {
        if (body) {
          var response = await baseServices.getDataN2(body, url);
          if (response.data && response.data.length > 0) {
            setState(BarStackedDataAPI(response));
            setTimeout(() => {
              getData();
            }, 150000);
          }
        } else {
          setState(BarStackedData());
          setTimeout(() => {
            getData();
          }, 150000);
        }
      } catch (err) {
        setTimeout(() => {
          getData();
        }, 15000);
      }
    };

    getData();
  }, [body, url]);

  return (
    <>
      {isCard === "1" ? (
        <Card className="m-0">
          <Card.Content style={{ minHeight: "0px" }} className="m-0 p-0">
            <Chart height={"320"} bars={{ stacking: "percent" }}>
              <Chart.Bar color="transparent" name="" data={[]} />
              {state.chartBar &&
                state.chartBar.map((y) => (
                  <Chart.Bar
                    color={y.color}
                    name={y.name}
                    data={y.datos}
                    pointWidth={9}
                    borderWidth={0}
                  />
                ))}

              <Chart.Title className="m-0" text={titleCard} align="left" />
              <Chart.YAxis showGridLines={false} visible={true} />
              <Chart.XAxis categories={state.categories} />
            </Chart>
          </Card.Content>
        </Card>
      ) : (
        <div>
          <Chart height={"320"} bars={{ stacking: "percent" }}>
            <Chart.Bar color="transparent" name="" data={[]} />
            {state.chartBar &&
              state.chartBar.map((y, i) => (
                <Chart.Bar
                  color={y.color}
                  name={y.name}
                  data={y.datos}
                  pointWidth={9}
                  borderWidth={0}
                />
              ))}

            <Chart.Title className="m-0" text={titleCard} align="left" />
            <Chart.YAxis showGridLines={false} visible={true} />
            <Chart.XAxis categories={state.categories} />
          </Chart>
        </div>
      )}
    </>
  );
};

export default BarStacked;
